/* eslint-disable max-len */
import { Outlet, useParams } from 'react-router-dom'

import { MainLayout } from '@layouts/main'

import { AddUserPage } from '@modules/admin/pages/add-user'
import { EditUserPage } from '@modules/admin/pages/edit-user'

import { AddPage } from '@modules/project/pages/add'
import { EditPage } from '@modules/project/pages/edit'

import { EditTaskLocalizationPage } from '@modules/project-planning/pages/edit-task-localization/edit-task-localization.page'

import { AddBuildingPage } from '@modules/project-zoning/pages/add-building'
import { EditBuildingPage } from '@modules/project-zoning/pages/edit-building'

import { AddFloorPage } from '@modules/project-zoning/pages/add-floor'
import { EditFloorPage } from '@modules/project-zoning/pages/edit-floor'

import { ManageZonesPage } from '@modules/project-zoning/pages/manage-zones'

import { AddCompanyPage } from '@modules/project-companies/pages/add-company'
import { EditCompanyPage } from '@modules/project-companies/pages/edit-company'

import { AddPlanPage } from '@modules/project-plans/pages/add'
import { EditPlanPage } from '@modules/project-plans/pages/edit'

import { AddTaskTemplatePage } from '@modules/project-library/pages/add-task-template'
import { EditTaskTemplatePage } from '@modules/project-library/pages/edit-task-template'

import { AddSequenceTemplatePage } from '@modules/project-library/pages/add-sequence-template'
import { EditSequenceTemplatePage } from '@modules/project-library/pages/edit-sequence-template'

import { AddDocumentPage } from '@modules/project-documents/pages/add'
import { EditDocumentPage } from '@modules/project-documents/pages/edit'

import { AddUserPage as AddProjectUserPage } from '@modules/project-users/pages/add'
import { EditUserPage as EditProjectUserPage } from '@modules/project-users/pages/edit'
import { EditEmailAutoPage } from '@modules/project-users/pages/edit-email-auto'

import { AddFormModelPage } from '@modules/project-form-models/pages/add-form-model'
import { EditFormModelPage } from '@modules/project-form-models/pages/edit-form-model'

import { FormPage } from '@modules/project-forms/pages/submit-form/submit-form.page'
import { AddFormPage } from '@modules/project-forms/pages/add-form/add-form.page'
import { EditFormPage } from '@modules/project-forms/pages/edit-form/edit-form.page'
import { EditFormLocalizationPage } from '@modules/project-forms/pages/edit-form-localization/edit-form-localization.page'

import { AddObservationPage } from '@modules/project-observations/pages/add-observation/add-observation.page'
import { EditObservationPage } from '@modules/project-observations/pages/edit-observation/edit-observation.page'
import { EditObservationLocalizationPage } from '@modules/project-observations/pages/edit-observation-localization/edit-observation-localization.page'

import { useModal } from '@hooks/app/modal.hook'

import { Breadcrumb } from '../../components/BreadCrumb'
import { LoggedUser } from '../../components/LoggedUser'
import { ProjectActions } from '../../components/ProjectActions/ProjectActions.component'
import { SideBarMenu } from '../../components/SideBarMenu'

export const MainPage = (): JSX.Element => {
  const { currentModals } = useModal()

  const { projectId } = useParams()

  return (
    <MainLayout
      SideBarComponent={<SideBarMenu />}
      SideBarFooterComponent={<LoggedUser />}
      HeaderComponent={<Breadcrumb />}
      ActionsComponent={projectId && <ProjectActions projectId={projectId} />}
      MainComponent={
        <>
          <Outlet />

          {currentModals.indexOf('add_user') != -1 && <AddUserPage />}
          {currentModals.indexOf('update_user') != -1 && <EditUserPage />}

          {currentModals.indexOf('add_project') != -1 && <AddPage />}
          {currentModals.indexOf('update_project') != -1 && <EditPage />}

          {currentModals.indexOf('add_building') != -1 && <AddBuildingPage />}
          {currentModals.indexOf('update_building') != -1 && <EditBuildingPage />}

          {currentModals.indexOf('add_floor') != -1 && <AddFloorPage />}
          {currentModals.indexOf('update_floor') != -1 && <EditFloorPage />}

          {currentModals.indexOf('manage_zones') != -1 && <ManageZonesPage />}

          {currentModals.indexOf('add_company') != -1 && <AddCompanyPage />}
          {currentModals.indexOf('update_company') != -1 && <EditCompanyPage />}

          {currentModals.indexOf('add_form_model') != -1 && <AddFormModelPage />}
          {currentModals.indexOf('update_form_model') != -1 && <EditFormModelPage />}

          {currentModals.indexOf('add_project_user') != -1 && <AddProjectUserPage />}
          {currentModals.indexOf('update_project_user') != -1 && <EditProjectUserPage />}

          {currentModals.indexOf('add_task_template') != -1 && <AddTaskTemplatePage />}
          {currentModals.indexOf('update_task_template') != -1 && <EditTaskTemplatePage />}

          {currentModals.indexOf('update_task_localization') != -1 && <EditTaskLocalizationPage />}

          {currentModals.indexOf('add_sequence') != -1 && <AddSequenceTemplatePage />}
          {currentModals.indexOf('update_sequence') != -1 && <EditSequenceTemplatePage />}

          {currentModals.indexOf('add_plan') != -1 && <AddPlanPage />}
          {currentModals.indexOf('update_plan') != -1 && <EditPlanPage />}

          {currentModals.indexOf('add_document') != -1 && <AddDocumentPage />}
          {currentModals.indexOf('update_document') != -1 && <EditDocumentPage />}

          {currentModals.indexOf('submit_form') != -1 && <FormPage />}
          {currentModals.indexOf('add_form') != -1 && <AddFormPage />}
          {currentModals.indexOf('update_form') != -1 && <EditFormPage />}
          {currentModals.indexOf('update_form_localization') != -1 && <EditFormLocalizationPage />}

          {currentModals.indexOf('add_observation') != -1 && <AddObservationPage />}
          {currentModals.indexOf('update_observation') != -1 && <EditObservationPage />}
          {currentModals.indexOf('update_observation_localization') != -1 && <EditObservationLocalizationPage />}

          {currentModals.indexOf('update_project_email_settings') != -1 && <EditEmailAutoPage />}
        </>
      }
    />
  )
}
